import { useState, useEffect } from 'react';
import { FiSave, FiMail, FiPhone, FiMapPin, FiTool } from 'react-icons/fi';
import { useAuth } from '../context/AuthContext';
import Input from '../components/Input';
import Button from '../components/Button';

const ProfileSettings = () => {
  const { user, updateProfile } = useAuth();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    gstNumber: '',
    city: '',
  });

  useEffect(() => {
    if (user) {
      setFormData({
        name: user.name || '',
        email: user.email || '',
        phone: user.phone || '',
        gstNumber: user.gstNumber || '',
        city: user.address?.city || '',
      });
    }
  }, [user]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const profileData = {
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
      gstNumber: formData.gstNumber || undefined,
      address: {
        city: formData.city,
      },
    };

    await updateProfile(profileData);
    setLoading(false);
  };

  return (
    <div className="auth-container">
      <div className="auth-background" />

      <div className="auth-content">
        <div className="auth-card">
          <div className="auth-header">
            <div className="auth-logo">
              <FiTool />
            </div>
            <h1 className="auth-title">Edit Profile</h1>
            <p className="auth-subtitle">Update your shop details</p>
          </div>

          <form onSubmit={handleSubmit} className="auth-form">
            <Input
              label="Shop Name"
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="ABC HVAC Services"
              required
            />

            <div className="register-grid">
              <Input
                label="Email"
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="shop@example.com"
                icon={<FiMail />}
                required
              />

              <Input
                label="Phone"
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="9876543210"
                icon={<FiPhone />}
                required
              />
            </div>

            <div className="register-grid">
              <Input
                label="GST number"
                type="text"
                name="gstNumber"
                value={formData.gstNumber}
                onChange={handleChange}
                placeholder="e.g. 27AABCU9603R1ZM"
              />

              <Input
                label="City"
                type="text"
                name="city"
                value={formData.city}
                onChange={handleChange}
                placeholder="Mumbai"
                icon={<FiMapPin />}
              />
            </div>

            <Button
              type="submit"
              variant="primary"
              size="lg"
              fullWidth
              loading={loading}
              icon={<FiSave />}
            >
              Save Changes
            </Button>
          </form>
        </div>

        <div className="auth-info">
          <h2>Keep your profile updated</h2>
          <p>Accurate shop information helps with better reports and communication.</p>
        </div>
      </div>
    </div>
  );
};

export default ProfileSettings;

